import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';

export const usePayForms = () => {
    const [payForms, setPayForms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPayForms = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axiosInstance.get('/api/payforms/active');
            setPayForms(response.data.data);
        } catch (err) {
            console.error('Error fetching active pay forms:', err);
            setError(err.message || 'Failed to fetch active payment forms');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPayForms();
    }, []);

    return {
        payForms,
        loading,
        error,
        refetch: fetchPayForms
    };
}; 